import { render } from "./UpdateNav.vue?vue&type=template&id=b95e744e"
import script from "./UpdateNav.vue?vue&type=script&lang=js"
export * from "./UpdateNav.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__